export default __webpack_public_path__ + "static/media/firmware-update.610f60f3.svg";